exports.strings = {
    // App.js
    "cookiesMessage": "Χρησιμοποιούμε cookies για να διασφαλίσουμε ότι σας προσφέρουμε την καλύτερη εμπειρία. Εάν συνεχίσετε να χρησιμοποιείτε αυτήν την εφαρμογή, συναινείτε στη χρήση των cookies.",
    "reviewAndSubmit": "Αναθεώρηση και υποβολή",
    "submit": "υποβάλλουν",
    "termsOfService": "Όρους Παροχής Υπηρεσιών",
    "termsOfServiceURL": "https://www.attestiv.com/legal/terms-of-service",
    "verificationMessage": "Επαληθεύω ότι όλες οι πληροφορίες που έχω δώσει είναι αληθείς και σωστές από όσο γνωρίζω. Συμφωνώ επίσης με τους",

    // location accuracies
    "locationAccuracy": "Ακρίβεια τοποθεσίας",
    "acceptable": "Δεκτός",
    "fair": "Ουδέτερος",
    "good": "Καλό",
    "great": "Εξαιρετική",
    "outstanding": "Εξοχος",
    "poor": "Κακό",
    
    // Summary.js
    "connecting": "Συνδετικός...",

    // Complete.js
    "complete": "Τέλος",

    // CaptureCamera.js
    "mediaCaptured": "Φωτογραφία τραβηγμένη",

    // buttons folder
    "nextButtonText": "Συνέχεια",

    // forms folder
    "required": "Απαιτείται",
};
